/**
 * FMA Home Page Tour Steps
 * Tour for Find My Agency landing page
 * Supports role-based messaging for agents vs agencies
 */
import { Step } from "react-joyride";

export function getFmaHomeSteps(isAgent: boolean): Step[] {
  return [
    {
      target: "body",
      content:
        "Welcome to Find My Agency! Discover life & health insurance agencies offering the best commissions, training and support. Let's show you around!",
      placement: "center",
      disableBeacon: true,
    },
    {
      target: '[data-tour="browse-agencies-cta"]',
      content: isAgent
        ? "Click 'Browse Agencies' to search and filter agency opportunities tailored to your goals."
        : "Browse fellow agencies to see what they have to offer and collaborate!",
      placement: "top",
      offset: 20,
      disableScrolling: true,
    },
    {
      target: '[data-tour="training-vault-cta"]',
      content: isAgent
        ? "Visit the 'Training Vault' to watch free training videos from top agencies and earn points."
        : "If you have an Elite or Pro subscription, head over to the Training Vault and post videos to attract the right agent!",
      placement: "top",
      offset: 20,
      disableScrolling: true,
    },
    {
      target: '[data-tour="account-link"]',
      content:
        "Click 'Account' in the navigation to manage your profile and settings.",
      placement: "bottom",
      disableScrolling: true,
    },
    {
      target: '[data-tour="topbar-account-link"]',
      content:
        "Access our powerful Agency Management Software (AMS), app settings, and account options from this menu.",
      placement: "bottom",
    },
    {
      target: "body",
      content:
        "That's it! Start exploring agencies or dive into training. Your journey begins now!",
      placement: "center",
    },
  ];
}
